<template>
  <!--콘텐츠 영역-->
  <div id="sub_contents" class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item NewsDK">
      <div class="tit">
        <h3>
          송원문화재단
          <span>배너</span>
        </h3>
      </div>
      <div class="News_tit News_bottom_p">
        <h4>{{ detail.title }}</h4>

        <p class="day">(생성일 : {{ detail.createdAt | date }})</p>
          <div class="txt News_bottom">
            <h4>게시기간 : {{ detail.startDt | date }} ~ {{ detail.endDt | date }}</h4>
            <h4>링크 url : {{ detail.contentUrl }}</h4>

            <h4>타입 : {{ selectedTypeText }}</h4>
          </div>




          <!-- <div class="img">
                  <img :src="detail.MAIN_IMG" />
          </div> -->



      </div>

      <div class="News_btn_area">
        <button class="btn_list" @click="btnGoList">목록</button>
        <button class="btn_list fl mgr10" v-if="isAdmin" @click="btnUpdate">수정</button>
        <button class="btn_list type01 fl" v-if="isAdmin" @click="btnDelete">삭제</button>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import pm from "../common/protocolManager";
import eventBus from "../common/eventBus";
import { bannerSelectType } from "../common/util";

export default {
  data: () => ({
    message: "BoardDetail.vue",
    isAdmin: false,
    detail: {
      title: "",
      contentUrl: "",
      startDt: "",
      endtDt: "",
      files: {}
    },
    selectedTypeText : "",




  }),
  methods: {
    checkAdmin() {
      let url = "isAdmin";
      pm.get(url)
        .then(result => {
          console.log("checkAdmin - ok");
          this.isAdmin = true;
        })
        .catch(err => {
          console.log("checkAdmin - err");
          this.isAdmin = false;
          if (localStorage.authToken) {
            localStorage.removeItem("authToken");
          }
        });
    },
    btnUpdate() {
      console.log("btnUpdate");
      this.$router.replace({
        path: `/notice/BannerWritePopup`,
        query: {
          id: this.$route.query.id,
        }
      });

    },
    btnGoList() {
      console.log("btnGoList");
      history.back();
    },
    btnDelete() {
      console.log("btnDelete");

      if (confirm("정말 삭제하시겠습니까?")) {
        let url = "bannerDelete";
        let params = {
          id: this.$route.query.id
        };
        pm.post(url, params)
          .then(result => {
            console.log("btnDelete ok");
            eventBus.$emit("EVENT_CHANGE_BANNER_LIST");
            alert("삭제되었습니다.");

            this.$router.replace("/");
          })
          .catch(err => {
            console.log("btnDelete err");
            alert("삭제 실패");
          });

        //   pm.post
      }
    },
    reqDetail() {
      let url = `bannerDetail?id=${this.$route.query.id}`;
      console.log("URL====" + url);

      pm.get(url)
        .then(result => {
          console.log("noticeDetail - ok");
          this.detail = result.detail;

          let tempTypeList = bannerSelectType();
          for (let i = 0; i < tempTypeList.length; i++){
            if (tempTypeList[i].value == this.detail.type) {
              this.selectedTypeText = tempTypeList[i].name;
            }
          }

          // if (this.detail.files != undefined) {
          //   if (this.detail.files && this.detail.files.bgImage.length) {
          //     this.detail.MAIN_IMG =
          //       pm.NAS_URL + this.detail.files.bgImage[0].filename;
          //   }
          // }

        })
        .catch(err => {
          console.log("noticeDetail - error");
        });
    }
  },
  computed: {
    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    }
  },
  destroyed() {
    eventBus.$off("EVENT_CHANGE_BANNER_DETAIL");
  },
  created() {
    console.log("created - " + this.message);

    this.selectList = bannerSelectType();



    if (this.$route.query.id) {
      console.log("this.$route.query.boardId = " + this.$route.query.id);
    }

    this.reqDetail();
    if (localStorage.authToken) {
      this.checkAdmin();
    }

    eventBus.$on("EVENT_CHANGE_BANNER_DETAIL", () => {
      console.log("EVENT_CHANGE_BANNER_DETAIL");
      this.reqDetail();
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/sub02/BannerDetail.vue